import React from 'react'
import { Switch } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { colors, StyledSpan } from '../../Global'

const styles = (theme) => ({
  colorBar: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: colors.lightGreen,
      '& + $iOSBar': { backgroundColor: colors.green }
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp
    })
  },
  iOSChecked: {
    transform: 'translateX(30px)',
    '& + $iOSBar': {
      opacity: 1,
      backgroundColor: colors.lightGreen
    }
  },
  iOSBar: {
    borderRadius: 13,
    width: 64,
    height: 28,
    marginTop: -13,
    marginLeft: -21,
    backgroundColor: colors.lightGrey,
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  iOSIcon: {
    color: colors.mediumGrey,
    width: 40,
    height: 40
  },
  iOSIconChecked: {
    color: colors.green,
    boxShadow: '-1px 2px 6px 0 rgba(0,0,0,0.45)'
  }
})

const SwitchComponent = (props) => {
  const {
    classes,
    defaultChecked,
    checked,
    onChange,
    showValue,
    ...other
  } = props

  return (
    <React.Fragment>
      <Switch
        {...other}
        defaultChecked={defaultChecked}
        classes={{
          root: classes.iOSSwitchBase,
          bar: classes.iOSBar,
          icon: classes.iOSIcon,
          iconChecked: classes.iOSIconChecked,
          checked: classes.iOSChecked
        }}
        disableRipple
        checked={checked}
        onChange={onChange}
        // value={preferences.tippedEmployees}
      />
      <StyledSpan style={(showValue) ? { marginLeft: '30px' } : { display: 'none' }}>
        {checked ? 'Yes' : 'No'}
      </StyledSpan>
    </React.Fragment>
  )
}

export default withStyles(styles)(SwitchComponent)
